import * as React from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import L from "leaflet";

const containerStyle = { width: "100%", height: "600px", position: "relative" as const };
const SATELLITE_URL = "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}";
const SATELLITE_SUBDOMAINS = ["mt0", "mt1", "mt2", "mt3"];

type ControllerProps = {
  mapRef: React.MutableRefObject<L.Map | undefined>;
  isDrawingModeEnabled: boolean;
};

function MapController({ mapRef, isDrawingModeEnabled }: ControllerProps) {
  const map = useMap();

  React.useEffect(() => {
    mapRef.current = map;
  }, [map, mapRef]);

  React.useEffect(() => {
    if (isDrawingModeEnabled) {
      map.dragging.disable();
      map.scrollWheelZoom.disable();
    } else {
      map.dragging.enable();
      map.scrollWheelZoom.enable();
    }
  }, [map, isDrawingModeEnabled]);

  return null;
}

type Props = {
  lat: number;
  lon: number;
  isDrawingModeEnabled: boolean;
  mapRef: React.MutableRefObject<L.Map | undefined>;
  children: React.ReactNode;
};

function LeafletMapWrapper({ lat, lon, isDrawingModeEnabled, mapRef, children }: Props) {
  return (
    <MapContainer center={[lat, lon]} zoom={20} style={containerStyle}>
      <TileLayer
        url={SATELLITE_URL}
        subdomains={SATELLITE_SUBDOMAINS}
        maxZoom={20}
        attribution="&copy; Google Maps"
      />
      <MapController mapRef={mapRef} isDrawingModeEnabled={isDrawingModeEnabled} />
      {children}
    </MapContainer>
  );
}

export default React.memo(LeafletMapWrapper);
